module.exports = __webpack_public_path__ + "fonts/deposit-detail-guide-1.c566a8b3s.png";